export const createReportExportGate = () => {
    let activeFormat = null;

    return {
        tryStart(format) {
            if (activeFormat) {
                return { started: false, activeFormat };
            }

            activeFormat = String(format || 'Report');
            return { started: true, activeFormat };
        },

        finish(format) {
            if (activeFormat === String(format || 'Report')) {
                activeFormat = null;
            }
        },

        getActiveFormat() {
            return activeFormat;
        },
    };
};
